import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import Sortable from 'react-native-sortables';
import Box from '@/components/UI/Box';
import type { EventScorekeepingPanelFormValues } from '../../EventScorekeeping.types';
import EventScorekeepingPanelPreviewRecipientItem from './EventScorekeepingPanelPreviewRecipientItem';

export default function EventScorekeepingPanelPreviewRecipientList() {
  const { control } = useFormContext<EventScorekeepingPanelFormValues>();

  const { move } = useFieldArray({
    control,
    name: 'recipients',
  });

  const recipients = useWatch({
    control,
    name: 'recipients',
  });

  const selectedRecipientId = useWatch({
    control,
    name: 'selectedRecipientId',
  });

  const nonDeletedRecipients = recipients.filter(
    (recipient) => !recipient.isDeleted,
  );

  const hasSiblings = nonDeletedRecipients.length > 1;

  return (
    <Box w="full">
      <Sortable.Grid
        onDragEnd={(data) => {
          move(data.fromIndex, data.toIndex);
        }}
        enableActiveItemSnap={false}
        activeItemScale={1.025}
        columns={1}
        data={recipients}
        renderItem={({ item, index }) => {
          return (
            <EventScorekeepingPanelPreviewRecipientItem
              recipient={item}
              index={index}
              isSelected={selectedRecipientId === item.id}
              hasSiblings={hasSiblings}
            />
          );
        }}
      />
    </Box>
  );
}
